const projectReducer = (state = {}, action) => {
    switch (action.type) {      
      case "SHIP_STATUS":
        return Object.assign({}, state, {
          shipStatus : action.data,
        });    
        case "SHIP_LIST":
          return Object.assign({}, state, {
            shipList : action.data,
          });
          case "SHIP_NAMES":
          return Object.assign({}, state, {
            shipNames : action.data,
          });    
      default:
        return state;
    }
  };
  
  export default projectReducer;
  